import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';

export default function DropdownButton({ className, option, onChange }) {
  return (
    <button
      id={`dropdown_option_${option.value}`}
      data-test-id={`dropdown_option_${option.value}`}
      type="button"
      className={classnames(
        'DropdownButton flex items-center font-16 tl hover-bg-near-white br2 w-100',
        className
      )}
      onClick={() => onChange(option.value)}
    >
      {option.icon && (
        <span
          className={classnames('mr3 pv2 ph2 br-100', option.iconBgClassName)}
        >
          <Icon name={option.icon} />
        </span>
      )}
      {option.label}
    </button>
  );
}

DropdownButton.propTypes = {
  className: PropTypes.string,
  option: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    iconBgClassName: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

DropdownButton.defaultProps = {
  className: null
};
